import { MathJaxContext } from "better-react-mathjax";
import { Route, Routes } from "react-router-dom";

import DistrictTemplate from "./segments/DistrictTemplate";
import GuardianHome from "./segments/GuardianHome";
import Home from "./segments/Home";
import Interrupt from "./components/guardian/Interrupt";
import LoadTest from "./components/LoadTest";
import Login from "./components/Login";
import ManageEprContent from "./segments/ManageEprContent";
import NotFound from "./components/NotFound";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import StudentSearch from "./segments/StudentSearch";
import TeacherHomeForAdmin from "./segments/TeacherHomeForAdmin";

/**
 * Routing for EPR
 * @name App
 * @return {JSX.Element}
 */
const App = () => {
    const config = {
        loader: { load: ["input/tex", "output/svg"] },
        tex: {
            inlineMath: [
                ["$", "$"],
                ["\\(", "\\)"]
            ]
        }
    };

    return (
        <MathJaxContext config={config} src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js">
            <Routes>
                {/* Protected Routes */}
                <Route path="/" element={<PrivateRoute />}>
                    {/* Main Pages */}
                    <Route index element={<Home />} />
                    <Route path="home" element={<Home />} />
                    <Route path="manage-epr-content" element={<ManageEprContent />} />
                    <Route path="district-template" element={<DistrictTemplate />} />
                    <Route path="student-search" element={<StudentSearch />} />

                    {/* Home Templates */}
                    <Route path="home/template" element={<Home />} />
                    <Route path="home/overview" element={<Home />} />
                    <Route path="home/report_card_overview" element={<Home />} />
                    <Route path="home/template/define" element={<Home />} />
                    <Route path="home/sles" element={<Home />} />

                    {/* Teacher Summary */}
                    <Route path="home/summary" element={<Home />} />
                    <Route path="home/student-search" element={<Home />} />

                    {/* Admin Teacher Views */}
                    <Route
                        path="home/teacher-view/:teacherGuid/:locationKey/:timePeriodKey/summary/input-ratings/student/:studentNumber"
                        element={<TeacherHomeForAdmin />}
                    />
                    <Route
                        path="home/teacher-view/:teacherGuid/:locationKey/:timePeriodKey/*"
                        element={<TeacherHomeForAdmin />}
                    />

                    {/* Roster Routes */}
                    <Route path="home/summary/roster">
                        <Route index element={<Home />} />
                        <Route path=":gradingProfileId" element={<Home />} />
                        <Route path=":gradingProfileId/groups" element={<Home />} />
                        <Route path="groups" element={<Home />} />
                    </Route>

                    {/* Share Routes */}
                    <Route path="home/summary/share">
                        <Route index element={<Home />} />
                        <Route path=":gradingProfileId" element={<Home />} />
                        <Route path=":gradingProfileId/groups" element={<Home />} />
                        <Route path=":gradingProfileId/groups/:homeroomGroupId" element={<Home />} />
                    </Route>

                    {/* Differentiation Routes */}
                    <Route path="home/summary/differentiation">
                        <Route index element={<Home />} />
                    </Route>

                    {/* Input Rating Routes */}
                    <Route path="home/summary/input-ratings">
                        <Route index element={<Home />} />
                        <Route path="homeroom" element={<Home />} />

                        <Route path="homeroom/:gradingProfileId" element={<Home />} />
                        <Route path="groups" element={<Home />} />
                        <Route path="student/:studentNumber" element={<Home />} />
                    </Route>

                    {/* Dev LoadTest */}
                    {process.env.NODE_ENV !== "production" && (
                        <Route path="loadtest/:userName" element={<LoadTest />} />
                    )}
                </Route>

                {/* Guardian */}
                <Route path="/login-welcome" element={<Interrupt />} />
                <Route path="/guardian" element={<PrivateRoute />}>
                    <Route index element={<GuardianHome />} />
                    <Route path="student-select" element={<GuardianHome />} />
                    <Route path=":studentNumber" element={<GuardianHome />} />
                    <Route path="recent/:studentNumber" element={<GuardianHome />} />
                    <Route path="archive/:studentNumber" element={<GuardianHome />} />
                </Route>
                {/* Public / Dev Routes */}
                {process.env.NODE_ENV !== "production" && (
                    <>
                        <Route path="/backdoor" element={<Login />} />
                        <Route path="/loadtest" element={<NotFound />} />
                    </>
                )}

                {/* Not Found Fallback */}
                <Route path="/notFound" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </MathJaxContext>
    );
};

export default App;
